import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from "@material-ui/core";
import {AiFillFilePdf} from 'react-icons/ai'

const rows = [
  { description: "Public Service Guarantee Act", pdfUrl: "https://tcp.hp.gov.in/Application/uploadDocuments/content/Public__Service_Guraunty.pdf" },
  { description: "Nodal officer for implementation of Public Service Guarantee ACT , 2011", pdfUrl: "https://tcp.hp.gov.in/Application/uploadDocuments/content/Nodal_Officer_PSA_1.pdf" },
  { description: "Public Service Guarantee Report", pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Pro_Active.pdf" },

]

const handlePdfDownload = (pdfUrl) => {
  window.open(pdfUrl);
};

const PublicActs = () => {
  return (
    <React.Fragment>
    <TableContainer component={Paper}>
    <Typography variant='h6' style={{margin: '20px'}}>
      Public Service Guarantee Act
    </Typography>
      <Table aria-label="Sample Table" style={{width: '90%', margin: '30px'}}>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.slNo}>
              <TableCell>{row.description}</TableCell>
              <TableCell onClick={() => handlePdfDownload(row.pdfUrl)}><AiFillFilePdf style={{width: '30px', height: '30px', color:'#f44b55', cursor: 'pointer' }}/></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </React.Fragment>
  );
};

export default PublicActs;
